// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
        margin: -5px !important;
        align-items: center;

        & > * {
            padding: 5px;
            line-height: 1;

            &:before {
                content: "|";
                padding-right: 10px;
                color: ${getColor("common.ui2")};
            }
            &:first-child {
                &:before {
                    content: none;
                }
            }
        }
    `,
};

headerStyles.lastUpdateText = {};

headerStyles.sharingStatus = {};

headerStyles.descriptionStyles = {
    heading: {
        css: css`
            display: none;
        `,
    },
};
